import { render } from "./UserInvitationList.vue?vue&type=template&id=765728fe"
import script from "./UserInvitationList.vue?vue&type=script&lang=js"
export * from "./UserInvitationList.vue?vue&type=script&lang=js"

import "./UserInvitationList.vue?vue&type=style&index=0&id=765728fe&lang=scss"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__